import api, { MetadataView } from 'api'
import AppAction from 'components/AppAction/AppAction'
import AppTableAction from 'components/AppAction/AppTableAction'
import AppDialog from 'components/AppDialog'
import { AppGridHeard } from 'components/AppGridLayout/AppGridHeard'
import AppGridLayout from 'components/AppGridLayout/AppGridLayout'
import AppGridMenu from 'components/AppGridLayout/AppGridMenu'
import AppGridTabs from 'components/AppGridLayout/AppGridTabs'
import AppGridView from 'components/AppGridLayout/AppGridView'
import { AppTable } from 'components/AppTable'
import { AppGridSearch } from 'components/AppTableSearch/AppGridSearch'
import React, { Component } from 'react'

import { ViewTable } from './components/ViewTable'
import DataViewFormPage from './DataViewFormPage'

interface DataTableProps {
	systemCode?: string
	callBack?: (data: MetadataView) => void
}

// 数据视图列表
export default class DataView extends Component<DataTableProps> {
	state = { tableSearch: { systemCode: this.props.systemCode, name: '' } }
	// 渲染前加载
	// componentWillMount = () => {
	// 	this.refreshTable()
	// }
	// 查询
	onSearch = (filterData: any, data?: any) => {
		console.log('data:', data)
		let tableSearch = { ...this.state.tableSearch, name: data.name || '' }
		this.setState({ tableSearch })
	}
	// 新建视图
	addViewItem = () => {
		let metadataView: MetadataView = {
			application: this.props.systemCode,
			id: 0,
			metadataVersion: '0.1',
			name: '',
		}
		AppDialog.open(
			<DataViewFormPage
				mode={1}
				metadataView={metadataView}
				systemCode={this.props.systemCode}
				afterSave={this.refreshTable}
			/>,
			{
				title: '新增视图',
				height: 310,
			}
		)
	}
	editView = (data: MetadataView) => {
		AppDialog.open(
			<ViewTable
				systemCode={this.props.systemCode}
				displayName={data.displayName}
				name={data.name}
				text={data.sqlText}
				viewAttr={data.metadataAttributeList}
				metadataView={data}
			/>,
			{
				size: 'full',
			}
		)
	}

	// 刷新Tabe
	refreshTable = () => {
		this.refTable && this.refTable.current && this.refTable.current.refreshData()
	}
	refTable = React.createRef<AppTable>()
	render() {
		return (
			<AppGridLayout defaultViewId={-1}>
				<AppGridSearch
					commonSearchList={[{ dataType: 'string', field: 'name', label: '请输入数据表名称' }]}
					onSearch={this.onSearch}
				/>
				<AppGridHeard>
					<AppGridTabs></AppGridTabs>
					<AppGridMenu>
						<AppAction title="新增" type="primary" action={this.addViewItem}></AppAction>
					</AppGridMenu>
				</AppGridHeard>
				<AppGridView viewId={-1}>
					<AppTable
						api={api.modeling.entity.getViewPageList}
						data={this.state.tableSearch}
						ref={this.refTable}
						onApiBefore={data => {
							return data.organId === 0 ? false : data
						}}
						rowKey="entityId"
						paging
					>
						<AppTable.ColIndex />
						<AppTable.Col title="中文名" align="center" field="displayName" width={200} />
						<AppTable.Col title="英文名" align="center" field="name" width={200} />
						<AppTable.Col title="状态" align="center" field="state" width={100} />
						<AppTable.Col title="修改人" align="center" field="modifiedBy" width={200} />
						<AppTable.ColDate title="修改时间" field="modifiedOn" width={150} />
						<AppTable.ColAction
							render={(data: MetadataView) => {
								return (
									<React.Fragment>
										<AppTableAction label="编辑" onClick={() => this.editView(data)} />
										<AppTableAction
											// onClick={() => this.deleteUser(user)}
											label="删除"
										/>
									</React.Fragment>
								)
							}}
						/>
					</AppTable>
				</AppGridView>
			</AppGridLayout>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/DataView.tsx